import { ChangeEvent } from "react"
import { ErrorMessage, useFormikContext } from "formik"

import { DropdownMenu } from "components/inputs/DropdownMenu"

import { countries } from "constants/countries"

export const CountrySelect = () => {
  const { setFieldValue, values } = useFormikContext<{ country: string }>()

  return (
    <div>
      <label htmlFor="country">Country</label>
      <DropdownMenu
        placeholder="All countries"
        options={countries}
        value={values.country}
        onChange={(ev: ChangeEvent<HTMLSelectElement>) => setFieldValue("country", ev.target.value)}
      />
      <ErrorMessage name="country" component="div" className="text-red text-sm" />
    </div>
  )
}
